<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!--  <vuexy-logo /> -->
          <b-img
            :src="require('@/assets/images/logo/PRYM-blue-small.png')"
            height="50%"
            alt="PRYM Logo"
          />
        </b-link>

        <div v-if="$route.params.submit === false && confirmed === false">
          <b-card-title class="mb-1 text-center">
            Please check your inbox for a verification code
            {{ this.$route.params.email }}
          </b-card-title>

          <!-- form -->
          <validation-observer ref="registerForm">
            <b-form
              class="auth-register-form mt-2"
              @submit.prevent="validationForm"
            >
              <!-- email -->
              <b-form-group
                label="Verfication Code"
                label-for="code"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Verification Code"
                  rules="required|digits:6"
                >
                  <b-form-input
                    id="code"
                    v-model="code"
                    :state="errors.length > 0 ? false:null"
                    name="code"
                    placeholder="123456"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button
                block
                type="submit"
              >
                Submit Code
              </b-button>
            </b-form>
          </validation-observer>
        </div>
        <div v-else-if="$route.params.submit === true && confirmed === false">
          <b-card-title class="mb-1 text-center">
            Confirming Your Account....
          </b-card-title>
        </div>
        <div v-else>
          <b-card-title class="mb-1 text-center">
            Your account has been confirmed!
          </b-card-title>

          <b-button
            block
            variant="primary"
            @click="goToLogin"
          >
            Login
          </b-button>
        </div>
      </b-card>
    <!-- /Register v1 -->
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardTitle, BForm, BImg,
  BButton, BFormInput, BFormGroup,
} from 'bootstrap-vue'
// import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { Auth } from 'aws-amplify'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    //   VuexyLogo,
    // BSV
    BImg,
    BCard,
    BLink,
    BCardTitle,

    BForm,
    BButton,
    BFormInput,
    BFormGroup,

    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      code: '',
      regEmail: '',
      confirmed: false,
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    if (this.$route.params.email) {
      this.regEmail = this.$route.params.email
    }
    if (this.$route.params.code) {
      this.code = this.$route.params.code
    }
    if (this.$route.params.submit === 'true') {
      this.confirmSignUp()
    }
  },
  methods: {
    async confirmSignUp() {
      try {
        const response = await Auth.confirmSignUp(this.regEmail, this.code)

        if (response === 'SUCCESS') {
          this.confirmed = true
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'BellIcon',
            text: error.toString(),
            variant: 'danger',
          },
        })
      }
    },
    goToLogin() {
      this.$router.push({ name: 'login', params: { email: this.regEmail } })
    },
    validationForm() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          this.confirmSignUp()
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.auth-wrapper.auth-v1 {
    background: url("https://uploads-ssl.webflow.com/61489b3e5856f80b844d9a07/61489b3e5856f824ec4d9b48_background-pricing-tech-ui-kit-webflow-template.svg");
}
.btn-secondary {
    border-color: #171663 !important;
    background-color: #171663!important;
}
a {
    color: #7844fc
}
</style>
